import { render, staticRenderFns } from "./BookingUser.vue?vue&type=template&id=6ef0283f&scoped=true"
import script from "./BookingUser.vue?vue&type=script&lang=ts"
export * from "./BookingUser.vue?vue&type=script&lang=ts"
import style0 from "./BookingUser.vue?vue&type=style&index=0&id=6ef0283f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef0283f",
  null
  
)

export default component.exports